import styled from "styled-components";

export const SectionButton = styled.div`
  display: flex;
`;
